import {Injectable} from '@angular/core';
import {AuthService} from '../auth.service';
import {CanActivate, Router} from '@angular/router';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const isLoggedIn = this.authService.isAuthentificated();

        /**
         * Есть ли токен?
         * Если нет, значит не авторизован, а если есть, то разрешаем только если успешно получили информацию о пользователе
         */
        if (isLoggedIn) {
            return this.authService.updateUserInfo();
        } else {
            this.authService.setRedirectUrl(state);
            this.router.navigate(['/login']);
            return false;
        }
    }
}
